import { render, staticRenderFns } from "./BrandManagement.vue?vue&type=template&id=abc9bcfc&"
import script from "./BrandManagement.vue?vue&type=script&lang=js&"
export * from "./BrandManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QIcon,QTd,QInput,QBtn,QPagination,QDialog,QCard,QCardSection,QCardActions,QInnerLoading,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QIcon,QTd,QInput,QBtn,QPagination,QDialog,QCard,QCardSection,QCardActions,QInnerLoading})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
